import Component from '../abstracts/Component';


/**
 Login component
 */
export default class PhoneNumberValidatorComponentChina extends Component {

  get SELECTORS() {
    return {
      phoneNumberInputFields: ".phone-number-live-adapter"
    };
  }

  constructor() {
    super();
  }

  render() {

    const {phoneNumberInputFields} = this.SELECTORS;

    const ctx=this;

    $(document).on("keypress",phoneNumberInputFields, function(e) {
      const isAFullPhoneNumberInputField=$(this).hasClass("with-prefix")
      const $input = $(this);
      const inputMaxLength = ctx.getMaxLengthFromInput($input, isAFullPhoneNumberInputField);
      const inputValue = $input.val();
      const length = inputValue.length;

      const keyCode = e.keyCode;
      const invalidCharset = keyCode !== 8 && keyCode !== 0 && keyCode < 48 || keyCode > 57;
      const invalidCharsetForFirstCharOnFullNumber = keyCode !== 43
      const isInputEmpty = length===0;
      // full number (prefix+number) need to allow "+" on first char
      if(
        isAFullPhoneNumberInputField && isInputEmpty ? invalidCharsetForFirstCharOnFullNumber:
        invalidCharset || length >= inputMaxLength
      ){
        e.preventDefault();
      }
    }).on('input',phoneNumberInputFields,function(e){
      const input=$(this);
      const data=e.originalEvent.data;
      const val = input.val();
      if(data==="" || data==="." || val.match(/[\.\s]/)){
        input.val(val.replace(/[\.\s]/g,""))
      } else {
        const isAFullPhoneNumberInputField = input.hasClass("with-prefix")
        const inputMaxLength = ctx.getMaxLengthFromInput(input, isAFullPhoneNumberInputField);
        input.val(val.substr(0, inputMaxLength));
      }
    })

  }

  getMaxLengthFromInput($input, isAFullPhoneNumberInputField) {
    const maxLengthAttr = $input.attr("maxlength");
    let inputMaxLength = parseInt(maxLengthAttr);
    return inputMaxLength > 0 ? inputMaxLength : isAFullPhoneNumberInputField ? 13 : 11;
  }
}
